// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BusinessFunctionAssetsQueryVariables = Types.Exact<{
  businessFunctionType: Types.BusinessFunctionType;
  orderBy?: Types.InputMaybe<Types.ChangeRequestAssetOrder>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type BusinessFunctionAssetsQuery = { __typename?: 'Query', changeRequestAssets: { __typename?: 'ChangeRequestAssetsPageResult', entities: Array<{ __typename?: 'ChangeRequestAsset', name: string, id: string, scopes: Array<Types.ChangeRequestAssetScope>, functionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, implementer: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, implementationReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, platform: { __typename?: 'ChangeRequestAssetPlatformDetail', code: Types.ChangeRequestAssetPlatform, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } }, enumDetails: { __typename?: 'AllEnumDetails', changeRequestAssetPlatform: Array<{ __typename?: 'ChangeRequestAssetPlatformDetail', code: Types.ChangeRequestAssetPlatform, name: string }>, changeRequestAssetScope: Array<{ __typename?: 'ChangeRequestAssetScopeDetail', code: Types.ChangeRequestAssetScope, name: string }> } };

export type SaveChangeRequestAssetsMutationVariables = Types.Exact<{
  input: Types.SaveChangeRequestAssetsInput;
}>;


export type SaveChangeRequestAssetsMutation = { __typename?: 'Mutation', saveChangeRequestAssets: { __typename: 'SaveChangeRequestAssetsResult', changeRequestAssets: Array<{ __typename?: 'ChangeRequestAsset', id: string, name: string }> } };

export type BusinessFunctionAssets_ChangeRequestAssetFragment = { __typename?: 'ChangeRequestAsset', name: string, id: string, scopes: Array<Types.ChangeRequestAssetScope>, functionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, implementer: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string }, implementationReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, platform: { __typename?: 'ChangeRequestAssetPlatformDetail', code: Types.ChangeRequestAssetPlatform, name: string } };

export const BusinessFunctionAssets_ChangeRequestAssetFragmentDoc = gql`
    fragment BusinessFunctionAssets_ChangeRequestAsset on ChangeRequestAsset {
  name
  id
  scopes
  functionType {
    code
    name
  }
  implementer {
    code
    name
  }
  implementationReviewer {
    code
    name
  }
  platform {
    code
    name
  }
}
    `;
export const BusinessFunctionAssetsDocument = gql`
    query BusinessFunctionAssets($businessFunctionType: BusinessFunctionType!, $orderBy: ChangeRequestAssetOrder, $page: PageFilter) {
  changeRequestAssets(
    filter: {functionType: $businessFunctionType}
    orderBy: $orderBy
    page: $page
  ) {
    entities {
      ...BusinessFunctionAssets_ChangeRequestAsset
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
  enumDetails {
    changeRequestAssetPlatform {
      code
      name
    }
    changeRequestAssetScope {
      code
      name
    }
  }
}
    ${BusinessFunctionAssets_ChangeRequestAssetFragmentDoc}`;

/**
 * __useBusinessFunctionAssetsQuery__
 *
 * To run a query within a React component, call `useBusinessFunctionAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessFunctionAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessFunctionAssetsQuery({
 *   variables: {
 *      businessFunctionType: // value for 'businessFunctionType'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBusinessFunctionAssetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables> & ({ variables: BusinessFunctionAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>(BusinessFunctionAssetsDocument, options);
      }
export function useBusinessFunctionAssetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>(BusinessFunctionAssetsDocument, options);
        }
// @ts-ignore
export function useBusinessFunctionAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>;
export function useBusinessFunctionAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BusinessFunctionAssetsQuery | undefined, BusinessFunctionAssetsQueryVariables>;
export function useBusinessFunctionAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>(BusinessFunctionAssetsDocument, options);
        }
export type BusinessFunctionAssetsQueryHookResult = ReturnType<typeof useBusinessFunctionAssetsQuery>;
export type BusinessFunctionAssetsLazyQueryHookResult = ReturnType<typeof useBusinessFunctionAssetsLazyQuery>;
export type BusinessFunctionAssetsSuspenseQueryHookResult = ReturnType<typeof useBusinessFunctionAssetsSuspenseQuery>;
export type BusinessFunctionAssetsQueryResult = Apollo.QueryResult<BusinessFunctionAssetsQuery, BusinessFunctionAssetsQueryVariables>;
export const SaveChangeRequestAssetsDocument = gql`
    mutation SaveChangeRequestAssets($input: SaveChangeRequestAssetsInput!) {
  saveChangeRequestAssets(input: $input) {
    __typename
    changeRequestAssets {
      id
      name
    }
  }
}
    `;
export type SaveChangeRequestAssetsMutationFn = Apollo.MutationFunction<SaveChangeRequestAssetsMutation, SaveChangeRequestAssetsMutationVariables>;

/**
 * __useSaveChangeRequestAssetsMutation__
 *
 * To run a mutation, you first call `useSaveChangeRequestAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChangeRequestAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChangeRequestAssetsMutation, { data, loading, error }] = useSaveChangeRequestAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveChangeRequestAssetsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChangeRequestAssetsMutation, SaveChangeRequestAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChangeRequestAssetsMutation, SaveChangeRequestAssetsMutationVariables>(SaveChangeRequestAssetsDocument, options);
      }
export type SaveChangeRequestAssetsMutationHookResult = ReturnType<typeof useSaveChangeRequestAssetsMutation>;
export type SaveChangeRequestAssetsMutationResult = Apollo.MutationResult<SaveChangeRequestAssetsMutation>;
export type SaveChangeRequestAssetsMutationOptions = Apollo.BaseMutationOptions<SaveChangeRequestAssetsMutation, SaveChangeRequestAssetsMutationVariables>;